export default __webpack_public_path__ + "static/media/AeonLogin.cdf15b0c.png";